import LayoutWrapper from "~/components/layouts/layoutWrapper";
import Product from "~/components/pages/product";
import Section from "~/components/pages/section";
import Sections from "~/components/pages/sections";
import Redis from "~/lib/redis";
import { wrapper } from "~/redux";
import { getBaltexSections } from "~/redux/action-creaters/baltex";
import { addBreadcrumb } from "~/redux/action-creaters/breadcrumbs";
import { checkIsBaltex } from "~/utils";
import {
  detectPageType,
  filterIndexLogic,
  filterLogic,
  PageTypes,
  productLogic,
  sectionLogic,
  sectionsLogic,
} from "~/utils/catalogSsrLogic";
import pagesWrapper from "~/utils/pagesWrapper";

export default function CatalogPage({
  pageType,
  section,
  scripts,
  isIndex,
  host,
}: any) {
  return (
    <LayoutWrapper scripts={scripts} isIndex={isIndex} host={host}>
      {pageType === PageTypes.sections && <Sections section={section} />}
      {(pageType === PageTypes.section || pageType === PageTypes.filter) && (
        <Section section={section} />
      )}
      {pageType === PageTypes.product && <Product />}
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(
  // @ts-ignore
  function (store) {
    return async ({ resolvedUrl, params, query, req }: any) => {
      // req.headers.host = 'baltex.ru';
      // req.headers.host = 'farkop-ford.ru';
      // req.headers.host = "spb.farkop-msk.ru";
      let { host } = req.headers;
      host = host.replace("farkop-msk.ru", "farkop.ru");
      host = host.replace("localhost:3000", "spb.farkop.ru");
      const isReset = Boolean(query.reset);
      store.dispatch(addBreadcrumb({ link: "/catalog/", name: "Каталог" }));
      const PageData: any = await detectPageType(store, params.code, isReset);
      let isIndex = true;
      if (PageData.pageType === PageTypes.filter) {
        const filterResult = filterLogic(PageData, store, host, resolvedUrl);
        if (filterResult) {
          return filterResult;
        }
        isIndex = filterIndexLogic(PageData, host.includes("baltex"));
      }

      let result = null;
      if (
        PageData.pageType === PageTypes.filter ||
        PageData.pageType === PageTypes.section
      ) {
        result = await sectionLogic(
          PageData,
          Redis,
          store,
          host,
          resolvedUrl,
          query,
          isReset,
        );
      } else if (PageData.pageType === PageTypes.product) {
        result = await productLogic(PageData, Redis, store, host, isReset);
      } else if (PageData.pageType === PageTypes.sections) {
        await sectionsLogic(PageData, store, host, isReset);
      } else if (PageData.pageType === PageTypes.notFound) {
        result = {
          notFound: true,
        };
      }
      if (result) {
        return result;
      }
      if (checkIsBaltex(host)) {
        await store.dispatch(getBaltexSections(isReset));
      }
      return pagesWrapper(
        {
          ...PageData,
          isIndex,
        },
        store,
        Redis,
        {
          query,
          req,
        },
        "/catalog/",
        false,
      );
    };
  },
);
